function detectExplorerEdge() {
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return true
  }

  return false
}

export default detectExplorerEdge
